// One-time migration of legacy `jarvis_*` localStorage keys to `nexo_*` (Passe 2 do rebrand).
// Safe to run on every boot: if the new key already exists OR the old key is absent, it's a no-op.
// Delete this file once analytics show no user has legacy keys (post Passe 5).

const MIGRATIONS = [
  ["jarvis_token", "nexo_token"],
  ["jarvis_voice_enabled", "nexo_voice_enabled"],
  ["jarvis_wakeword_enabled", "nexo_wakeword_enabled"],
  ["jarvis_session_id", "nexo_session_id"],
  ["jarvis_user_id", "nexo_user_id"],
];

export function migrateLegacyStorage() {
  for (const [oldKey, newKey] of MIGRATIONS) {
    try {
      const val = localStorage.getItem(oldKey);
      if (val !== null && localStorage.getItem(newKey) === null) {
        localStorage.setItem(newKey, val);
        localStorage.removeItem(oldKey);
        console.log("[Nexo] Migrated legacy localStorage key:", oldKey, "→", newKey);
      }
    } catch {
      // ignore storage access errors (private mode, etc.)
    }
  }
}
